export default function Favourite({ onClick, isAdded }) {
  return (
    <button
      className="btn-fav cursor-pointer border-0 bg-transparent p-0"
      onClick={onClick}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick(e);
        }
      }}
      aria-label={isAdded ? "Remove from favorites" : "Add to favorites"}
      aria-pressed={isAdded}
      type="button"
    >
      {isAdded ? (
        <i
          className="fa-solid fa-star text-warning fs-5"
          aria-hidden="true"
        ></i>
      ) : (
        <i
          className="fa-regular fa-star text-warning fs-5"
          aria-hidden="true"
        ></i>
      )}
    </button>
  );
}
